const Empty = () => {
  return <>&mdash;</>;
};

export default Empty;
